import { FormInitializerReturnTypeZod, ValidationMessageKeys } from 'src/Configuration/validation'
import { CompanyConfigurationFormModel } from 'src/Libs/installations/models/installation.model'
import { z } from 'zod'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useMemo } from 'react'
import { AccountLinkModel } from 'src/Libs/installation-rights-management/models'

export const useCompanyConfigurationFormInitializer = (
  companyAccountLink?: AccountLinkModel
): FormInitializerReturnTypeZod<CompanyConfigurationFormModel, CompanyConfigurationFormModel> => {
  const { t } = useCustomTranslation()
  const accountIdAsNumber =
    typeof companyAccountLink?.accountId === 'string' ? Number.parseInt(companyAccountLink.accountId) : companyAccountLink?.accountId

  const initialValues: CompanyConfigurationFormModel = useMemo(() => {
    return {
      companyId: accountIdAsNumber,
    }
  }, [accountIdAsNumber])

  const validationSchema = z.object({
    companyId: z.number({ message: t(ValidationMessageKeys.required) }),
  })

  return { initialValues, validationSchema }
}
